import { css } from 'lit';
export const walletAccountViewStyle = css `
  :host {
    width: 100%;
    height: 100%;
  }
`;
//# sourceMappingURL=wallet-account-view.style.js.map